"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebPageEnv = exports.isServiceWorkerEnv = void 0;
function isServiceWorkerEnv() {
    return typeof importScripts === 'function';
}
exports.isServiceWorkerEnv = isServiceWorkerEnv;
function isWebPageEnv() {
    return typeof window === 'object';
}
exports.isWebPageEnv = isWebPageEnv;
